import Translations from "@/types/translations";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

interface TranslationsOptions {
  preferredLanguage?: string;
  nameIsOptional?: boolean;
}
const getTextFromTranslations = (
  translations?: Translations[],
  { preferredLanguage, nameIsOptional }: TranslationsOptions = {
    nameIsOptional: false,
  }
): Translations | undefined => {
  if (!translations) return undefined;
  const { language: currentLanguage } = i18next;
  const language = preferredLanguage ?? currentLanguage;

  const foundObject = translations.find((t) => t.language === language);
  return (nameIsOptional ? foundObject : foundObject?.name)
    ? foundObject
    : translations.find((t) => t.language === "nl");
};

export const useTextFromTranslations = (
  translations: Translations[] | undefined,
  options?: Omit<TranslationsOptions, "preferredLanguage">
) => {
  const { i18n } = useTranslation();
  return getTextFromTranslations(translations, { ...options, preferredLanguage: i18n.language });
};

export { getTextFromTranslations };
